import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { AppMaterialModule } from '../../../shared/appMaterial/app-material.module';
import { BookingDetailsWrapperResolve } from './booking-details-wrapper.resolve';
import { BookingDetailsWrapperComponent } from './booking-details-wrapper.component';
import { BookingDetailsModule } from './booking-details/booking-details.module';
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AppMaterialModule,
    BookingDetailsModule,
  ],
  declarations: [BookingDetailsWrapperComponent],
  providers: [BookingDetailsWrapperResolve],
})
export class BookingDetailsWrapperModule {}
